import { useEffect } from 'react';
import { dateWithTimeZone } from "../../../../../utilities/utils";

const utmCampaignValue = 'hardselllogan';
const utmSourceValue = 'phd';

const LoganPixel = ({ model }) => {
  useEffect(() => {
    let expirationDate = new Date("2025-03-01");//YYYY-MM-DD
    const utmCampaign = sessionStorage.getItem("utm_campaign");
    const utmSource = sessionStorage.getItem("utm_source");

    if( dateWithTimeZone() < expirationDate  && utmCampaign === utmCampaignValue && utmSource === utmSourceValue ) {
      if (model?.name === 'Q3' || model?.name === 'Q5') {
        const imgPixel  = document.createElement('img');
        imgPixel.src    = 'https://pixel.loganmedia.mobi/pixel/c/41504';
        imgPixel.width  = 1;
        imgPixel.height = 1;
        imgPixel.style  = 'display: none';
        imgPixel.id     = "phd-logan-pixel-script";
        
        document.body.appendChild(imgPixel);
      }
    }
  }, [model]);

  return (<></>);
};

export default LoganPixel;